var _defs, _line, _line2, _line3, _line4, _line5, _line6, _line7, _polyline, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _polygon, _polyline2, _polyline3, _line20, _line21, _polyline4, _line22, _polyline5, _line23, _line24, _line25, _polyline6, _polyline7, _polyline8, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _polyline9, _line35, _polyline10, _line36, _line37, _line38, _line39, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16, _line40, _line41, _line42, _line43, _polyline11, _line44, _polyline12, _line45, _text17, _text18, _polyline13, _g, _g2, _polyline14, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _text19, _polygon2, _text20, _text21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFloor2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1854.37 1589.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#6d6d6d;stroke-width:5px;}.cls-1,.cls-2,.cls-3,.cls-4{fill:none;stroke-miterlimit:10;}.cls-5{fill:#84bd00;}.cls-6{letter-spacing:-.1em;}.cls-7{font-size:20px;}.cls-7,.cls-8,.cls-9{font-family:Mundial-Thin, Mundial;font-weight:200;}.cls-10{letter-spacing:0em;}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:0em;}.cls-8{font-size:10px;}.cls-13{letter-spacing:-.1em;}.cls-9{font-size:9px;}.cls-2{stroke-dasharray:0 0 12.94 12.94;}.cls-2,.cls-3,.cls-4{stroke:#84bd00;}.cls-3{stroke-dasharray:0 0 12.1 12.1;}.cls-14{letter-spacing:0em;}.cls-15{letter-spacing:-.02em;}.cls-16{letter-spacing:-.01em;}.cls-17{letter-spacing:0em;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.84,
    y1: 821.22,
    x2: 827.97,
    y2: 821.22
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 873.84,
    y1: 825.2,
    x2: 827.97,
    y2: 825.2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 926.58,
    y1: 821.22,
    x2: 880.06,
    y2: 821.22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 926.58,
    y1: 825.2,
    x2: 880.06,
    y2: 825.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 758.8,
    y1: 986.16,
    x2: 731.36,
    y2: 986.16
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 758.8,
    y1: 990.13,
    x2: 731.36,
    y2: 990.13
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1622.74,
    y1: 1243.1,
    x2: 1098.15,
    y2: 62.41
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "368.89 692.74 292.06 1140 292.1 1455.15 1121.82 1454.12"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.13,
    y1: 821.22,
    x2: 671.56,
    y2: 821.22
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 706.13,
    y1: 825.23,
    x2: 671.56,
    y2: 825.23
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 754.27,
    y1: 821.22,
    x2: 718.29,
    y2: 821.22
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 754.27,
    y1: 825.2,
    x2: 718.29,
    y2: 825.2
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 667.08,
    y1: 924.68,
    x2: 667.08,
    y2: 962.09
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 671.06,
    y1: 924.68,
    x2: 671.06,
    y2: 962.09
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 854.97,
    y1: 990.14,
    x2: 896.15,
    y2: 990.14
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 854.97,
    y1: 986.15,
    x2: 896.15,
    y2: 986.15
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 993.66,
    y1: 900.2,
    x2: 1020.69,
    y2: 900.25
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 993.67,
    y1: 896.17,
    x2: 1020.7,
    y2: 896.22
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1033.26,
    y1: 857.23,
    x2: 1033.26,
    y2: 828.88
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 1029.27,
    y1: 857.23,
    x2: 1029.27,
    y2: 828.88
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1097.12 64.83 803.76 146.21 279.63 145.39 371.31 696.24 370.97 1374.44 1123.85 1451.27 1591.63 1451.27 1620.58 1243.51 1302.52 824.2 1343.86 693.86 1097.12 64.83"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "509.6 824.2 509.6 988.14 623.65 988.14"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "623.37 830.16 623.37 822.62 371.24 822.59"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 623.37,
    y1: 990.65,
    x2: 623.37,
    y2: 858.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 758.71,
    y1: 988.14,
    x2: 856,
    y2: 988.14
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "669.07 962.09 669.07 988.14 731.36 988.14"
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 669.07,
    y1: 820.71,
    x2: 669.07,
    y2: 924.68
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "705 823.22 718.96 823.22 718.96 986.16"
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 667.69,
    y1: 879.78,
    x2: 718.71,
    y2: 879.78
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 658.81,
    y1: 899.85,
    x2: 770.14,
    y2: 899.85
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 767.71,
    y1: 821.44,
    x2: 767.71,
    y2: 989.13
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "768.85 930.25 984.39 930.25 984.39 988.14 896.16 988.14"
  })), _polyline7 || (_polyline7 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "925.07 830.16 925.07 823.22 984.39 823.22 984.39 934.28"
  })), _polyline8 || (_polyline8 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "754.27 823.22 825.48 823.22 825.48 830.16"
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 873.86,
    y1: 823.22,
    x2: 880.07,
    y2: 823.22
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 876.97,
    y1: 860.85,
    x2: 876.97,
    y2: 929.63
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 849.13,
    y1: 980.92,
    x2: 849.13,
    y2: 989.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 850.1,
    y1: 932.41,
    x2: 850.1,
    y2: 956.44
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 901.95,
    y1: 980.92,
    x2: 901.95,
    y2: 990.14
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 902.02,
    y1: 933.32,
    x2: 902.02,
    y2: 957.35
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 862.79,
    y1: 861.19,
    x2: 891.76,
    y2: 861.19
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 985.34,
    y1: 898.21,
    x2: 993.67,
    y2: 898.21
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1020.7,
    y1: 898.21,
    x2: 1031.12,
    y2: 898.21
  })), _polyline9 || (_polyline9 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1031.27 855.59 1031.27 988.85 1122.15 988.85 1122.15 824.5"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 529.56,
    y1: 824.22,
    x2: 529.56,
    y2: 988.43
  })), _polyline10 || (_polyline10 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "1302.52 824.5 1031.27 824.5 1031.27 828.88"
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1123.76,
    y1: 988.85,
    x2: 1143.65,
    y2: 988.85
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1141.13,
    y1: 826.69,
    x2: 1141.13,
    y2: 988.85
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 625.35,
    y1: 858.5,
    x2: 625.35,
    y2: 830.16
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 621.37,
    y1: 858.5,
    x2: 621.37,
    y2: 830.16
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1118.28,
    y: 1449.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(-449.91 2395.79) rotate(-83.26)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1099.12,
    y: 1447.27,
    width: 8.95,
    height: 2.91,
    transform: "translate(-464.57 2374.76) rotate(-83.26)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1077.57,
    y: 1445.02,
    width: 8.95,
    height: 2.91,
    transform: "translate(-481.37 2351.38) rotate(-83.26)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1055.11,
    y: 1442.48,
    width: 8.95,
    height: 2.91,
    transform: "translate(-498.67 2326.83) rotate(-83.26)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1033.62,
    y: 1439.83,
    width: 8.95,
    height: 2.91,
    transform: "translate(-515.01 2303.16) rotate(-83.26)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1011.56,
    y: 1437.86,
    width: 8.95,
    height: 2.91,
    transform: "translate(-532.53 2279.5) rotate(-83.26)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 989.66,
    y: 1435.99,
    width: 8.95,
    height: 2.91,
    transform: "translate(-549.99 2256.1) rotate(-83.26)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 967.8,
    y: 1434.02,
    width: 8.95,
    height: 2.91,
    transform: "translate(-567.33 2232.66) rotate(-83.26)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 946.27,
    y: 1431.48,
    width: 8.95,
    height: 2.91,
    transform: "translate(-583.82 2209.03) rotate(-83.26)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 924.14,
    y: 1429.4,
    width: 8.95,
    height: 2.91,
    transform: "translate(-601.29 2185.23) rotate(-83.26)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 902.43,
    y: 1427.32,
    width: 8.95,
    height: 2.91,
    transform: "translate(-618.38 2161.82) rotate(-83.26)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 880.31,
    y: 1425.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(-636.11 2138.25) rotate(-83.26)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 858.45,
    y: 1422.89,
    width: 8.95,
    height: 2.91,
    transform: "translate(-652.8 2114.24) rotate(-83.26)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 836.66,
    y: 1420.89,
    width: 8.95,
    height: 2.91,
    transform: "translate(-670.05 2090.83) rotate(-83.26)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 814.96,
    y: 1418.27,
    width: 8.95,
    height: 2.91,
    transform: "translate(-686.61 2066.97) rotate(-83.26)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 793.28,
    y: 1415.77,
    width: 8.95,
    height: 2.91,
    transform: "translate(-703.26 2043.22) rotate(-83.26)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 771.24,
    y: 1413.6,
    width: 8.95,
    height: 2.91,
    transform: "translate(-720.56 2019.42) rotate(-83.26)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 749.24,
    y: 1410.93,
    width: 8.95,
    height: 2.91,
    transform: "translate(-737.33 1995.22) rotate(-83.26)"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 727.45,
    y: 1408.98,
    width: 8.95,
    height: 2.91,
    transform: "translate(-754.62 1971.86) rotate(-83.26)"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 705.59,
    y: 1407.26,
    width: 8.95,
    height: 2.91,
    transform: "translate(-772.21 1948.64) rotate(-83.26)"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 683.75,
    y: 1404.68,
    width: 8.95,
    height: 2.91,
    transform: "translate(-788.92 1924.67) rotate(-83.26)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 661.92,
    y: 1402.67,
    width: 8.95,
    height: 2.91,
    transform: "translate(-806.2 1901.22) rotate(-83.26)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 640.05,
    y: 1400.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-822.94 1877.21) rotate(-83.26)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 618.23,
    y: 1398.05,
    width: 8.95,
    height: 2.91,
    transform: "translate(-840.18 1853.75) rotate(-83.26)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 596.15,
    y: 1395.44,
    width: 8.95,
    height: 2.91,
    transform: "translate(-857.08 1829.52) rotate(-83.26)"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 574.38,
    y: 1393.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-874.28 1806.11) rotate(-83.26)"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 552.51,
    y: 1391.47,
    width: 8.95,
    height: 2.91,
    transform: "translate(-891.66 1782.67) rotate(-83.26)"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 530.97,
    y: 1388.72,
    width: 8.95,
    height: 2.91,
    transform: "translate(-907.93 1758.85) rotate(-83.26)"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 508.66,
    y: 1386.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(-925.78 1735.05) rotate(-83.26)"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 487.11,
    y: 1384.31,
    width: 8.95,
    height: 2.91,
    transform: "translate(-942.27 1711.4) rotate(-83.26)"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 464.93,
    y: 1381.69,
    width: 8.95,
    height: 2.91,
    transform: "translate(-959.25 1687.06) rotate(-83.26)"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 443.37,
    y: 1380.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-976.69 1664.23) rotate(-83.26)"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 421.53,
    y: 1377.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(-993.4 1640.27) rotate(-83.26)"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 398.66,
    y: 1376.1,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1012.19 1616.31) rotate(-83.26)"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 377.3,
    y: 1373.57,
    width: 8.95,
    height: 2.91,
    transform: "translate(-1028.54 1592.88) rotate(-83.26)"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.39,
    y: 1355.69,
    width: 8.95,
    height: 2.91
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(892.35 1201.69)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(580.25 942.33) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1083.34 942.33) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 9.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 16.02,
    y: 0
  }, "eppen"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(676.88 937.77)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 4.51,
    y: 0
  }, "echnik"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 5.22,
    y: 12
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 8.73,
    y: 12
  }, "aum"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(678.08 859.09)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(727.52 871.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Lift"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(804.42 886.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(787.75 909.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hee"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 37.39,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.33,
    y: 0
  }, "en"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(914.17 886.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(897.65 909.88)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Damen"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(687.71 372.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "B\xFC"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 24.53,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 31.46,
    y: 0
  }, "o"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(927.37 968.75)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(790.37 968.55)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 0,
    y: 0
  }, "W"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.77,
    y: 0
  }, "C"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(676.56 893.29)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(1134.71 913.54) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "cls-9",
    transform: "translate(521.72 915.9) rotate(-89.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Schac"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 25.11,
    y: 0
  }, "h"), /*#__PURE__*/React.createElement("tspan", {
    x: 30.32,
    y: 0
  }, "t"))), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 631.34,
    y1: 899.85,
    x2: 623.65,
    y2: 899.85
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 658.78,
    y1: 897.86,
    x2: 631.34,
    y2: 897.86
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 658.78,
    y1: 901.84,
    x2: 631.34,
    y2: 901.84
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 559.1,
    y1: 800.08,
    x2: 569.7,
    y2: 823.22
  })), _polyline11 || (_polyline11 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "558.32 601.75 564.42 588.22 624.48 588.22"
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 793.72,
    y1: 588.15,
    x2: 831.25,
    y2: 588.15
  })), _polyline12 || (_polyline12 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "959.71 588.09 984.65 588.09 988.87 598.9"
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 1031.27,
    y1: 804.32,
    x2: 1031.27,
    y2: 824.5
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(697.59 707.18)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 0,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    x: 12.5,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 23.78,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.58,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 45.86,
    y: 0
  }, "p"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.12,
    y: 0
  }, "tion"))), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(747.37 791.34)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gang"))), _polyline13 || (_polyline13 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "559.1 800.08 514.97 702 558.32 601.75"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 624.48,
    y1: 588.22,
    x2: 630.48,
    y2: 588.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 642.57,
    y1: 588.21,
    x2: 781.67,
    y2: 588.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 787.72,
    y1: 588.15,
    x2: 793.72,
    y2: 588.15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 831.25,
    y1: 588.22,
    x2: 837.25,
    y2: 588.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 850.19,
    y1: 588.21,
    x2: 947.24,
    y2: 588.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 953.71,
    y1: 588.15,
    x2: 959.71,
    y2: 588.15
  }))), _polyline14 || (_polyline14 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-4",
    points: "988.87 598.9 1031.3 706.9 1031.27 804.32"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1095.57,
    y: 71.28,
    width: 8.95,
    height: 2.91,
    transform: "translate(48.41 403.58) rotate(-21.25)"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1103.83,
    y: 92.53,
    width: 8.95,
    height: 2.91,
    transform: "translate(41.27 408.01) rotate(-21.25)"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1112.48,
    y: 113.23,
    width: 8.95,
    height: 2.91,
    transform: "translate(34.36 412.56) rotate(-21.25)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1120.8,
    y: 134.62,
    width: 8.95,
    height: 2.91,
    transform: "translate(27.17 417.02) rotate(-21.25)"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1128.03,
    y: 153.22,
    width: 8.95,
    height: 2.91,
    transform: "translate(20.92 420.91) rotate(-21.25)"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1135.87,
    y: 173.48,
    width: 8.95,
    height: 2.91,
    transform: "translate(14.12 425.12) rotate(-21.25)"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1144.44,
    y: 193.74,
    width: 8.95,
    height: 2.91,
    transform: "translate(7.36 429.61) rotate(-21.25)"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1151.92,
    y: 214.74,
    width: 8.95,
    height: 2.91,
    transform: "translate(.26 433.75) rotate(-21.25)"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1160.75,
    y: 235.4,
    width: 8.95,
    height: 2.91,
    transform: "translate(-6.63 438.35) rotate(-21.25)"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1168.57,
    y: 255.83,
    width: 8.95,
    height: 2.91,
    transform: "translate(-13.5 442.57) rotate(-21.25)"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1176.51,
    y: 276.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-20.42 446.85) rotate(-21.25)"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1184.48,
    y: 297.12,
    width: 8.95,
    height: 2.91,
    transform: "translate(-27.39 451.14) rotate(-21.25)"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1200.54,
    y: 337.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-40.85 459.7) rotate(-21.25)"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1192.63,
    y: 317.38,
    width: 8.95,
    height: 2.91,
    transform: "translate(-34.17 455.47) rotate(-21.25)"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1208.28,
    y: 357.21,
    width: 8.95,
    height: 2.91,
    transform: "translate(-47.54 463.85) rotate(-21.25)"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1216.45,
    y: 378.3,
    width: 8.95,
    height: 2.91,
    transform: "translate(-54.63 468.25) rotate(-21.25)"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1302.99,
    y: 829.86,
    width: 8.95,
    height: 2.91,
    transform: "translate(-238.88 928.16) rotate(-36.03)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1309.54,
    y: 837.21,
    width: 8.95,
    height: 2.91,
    transform: "translate(-241.94 933.42) rotate(-36.03)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1322.36,
    y: 854.84,
    width: 8.95,
    height: 2.91,
    transform: "translate(-249.86 944.34) rotate(-36.03)"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1335.9,
    y: 872.46,
    width: 8.95,
    height: 2.91,
    transform: "translate(-257.64 955.67) rotate(-36.03)"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1349.51,
    y: 889.88,
    width: 8.95,
    height: 2.91,
    transform: "translate(-265.28 967.01) rotate(-36.03)"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1362.61,
    y: 907.36,
    width: 8.95,
    height: 2.91,
    transform: "translate(-273.06 978.06) rotate(-36.03)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1375.85,
    y: 924.85,
    width: 8.95,
    height: 2.91,
    transform: "translate(-280.81 989.19) rotate(-36.03)"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1389.17,
    y: 942.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-288.6 1000.39) rotate(-36.03)"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1402.41,
    y: 959.97,
    width: 8.95,
    height: 2.91,
    transform: "translate(-296.39 1011.54) rotate(-36.03)"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1415.88,
    y: 977.46,
    width: 8.95,
    height: 2.91,
    transform: "translate(-304.1 1022.8) rotate(-36.03)"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1428.97,
    y: 994.88,
    width: 8.95,
    height: 2.91,
    transform: "translate(-311.84 1033.84) rotate(-36.03)"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1442.36,
    y: 1012.51,
    width: 8.95,
    height: 2.91,
    transform: "translate(-319.65 1045.09) rotate(-36.03)"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1455.53,
    y: 1029.92,
    width: 8.95,
    height: 2.91,
    transform: "translate(-327.38 1056.17) rotate(-36.03)"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1468.85,
    y: 1047.56,
    width: 8.95,
    height: 2.91,
    transform: "translate(-335.2 1067.38) rotate(-36.03)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1482.17,
    y: 1065.19,
    width: 8.95,
    height: 2.91,
    transform: "translate(-343.03 1078.58) rotate(-36.03)"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1494.99,
    y: 1082.82,
    width: 8.95,
    height: 2.91,
    transform: "translate(-350.94 1089.5) rotate(-36.03)"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1508.36,
    y: 1100.24,
    width: 8.95,
    height: 2.91,
    transform: "translate(-358.63 1100.7) rotate(-36.03)"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1521.9,
    y: 1117.73,
    width: 8.95,
    height: 2.91,
    transform: "translate(-366.33 1112.01) rotate(-36.03)"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1535.14,
    y: 1135.22,
    width: 8.95,
    height: 2.91,
    transform: "translate(-374.08 1123.14) rotate(-36.03)"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1548.83,
    y: 1152.56,
    width: 8.95,
    height: 2.91,
    transform: "translate(-381.67 1134.51) rotate(-36.03)"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1561.69,
    y: 1170.24,
    width: 8.95,
    height: 2.91,
    transform: "translate(-389.61 1145.46) rotate(-36.03)"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1575.1,
    y: 1187.61,
    width: 8.95,
    height: 2.91,
    transform: "translate(-397.26 1156.67) rotate(-36.03)"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1588.04,
    y: 1205.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-405.25 1167.69) rotate(-36.03)"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1601.44,
    y: 1222.88,
    width: 8.95,
    height: 2.91,
    transform: "translate(-412.97 1178.91) rotate(-36.03)"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1610.82,
    y: 1235.78,
    width: 8.95,
    height: 2.91,
    transform: "translate(-418.76 1186.9) rotate(-36.03)"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 278.35,
    y: 158.58,
    width: 8.95,
    height: 2.91,
    transform: "translate(-23.47 51.5) rotate(-9.99)"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 281.98,
    y: 180.49,
    width: 8.95,
    height: 2.91,
    transform: "translate(-27.22 52.46) rotate(-9.99)"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 285.13,
    y: 202.41,
    width: 8.95,
    height: 2.91,
    transform: "translate(-30.98 53.34) rotate(-9.99)"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 288.98,
    y: 224.23,
    width: 8.95,
    height: 2.91,
    transform: "translate(-34.7 54.33) rotate(-9.99)"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 293.02,
    y: 245.79,
    width: 8.95,
    height: 2.91,
    transform: "translate(-38.38 55.36) rotate(-9.99)"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 295.99,
    y: 267.43,
    width: 8.95,
    height: 2.91,
    transform: "translate(-42.09 56.21) rotate(-9.99)"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 299.79,
    y: 289,
    width: 8.95,
    height: 2.91,
    transform: "translate(-45.78 57.19) rotate(-9.99)"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 303.6,
    y: 310.63,
    width: 8.95,
    height: 2.91,
    transform: "translate(-49.47 58.18) rotate(-9.99)"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 307.08,
    y: 332.24,
    width: 8.95,
    height: 2.91,
    transform: "translate(-53.17 59.11) rotate(-9.99)"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 310.93,
    y: 354.17,
    width: 8.95,
    height: 2.91,
    transform: "translate(-56.91 60.11) rotate(-9.99)"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 313.93,
    y: 376.08,
    width: 8.95,
    height: 2.91,
    transform: "translate(-60.67 60.97) rotate(-9.99)"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 317.7,
    y: 397.43,
    width: 8.95,
    height: 2.91,
    transform: "translate(-64.32 61.94) rotate(-9.99)"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 324.82,
    y: 440.78,
    width: 8.95,
    height: 2.91,
    transform: "translate(-71.73 63.84) rotate(-9.99)"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 321.04,
    y: 419.29,
    width: 8.95,
    height: 2.91,
    transform: "translate(-68.06 62.85) rotate(-9.99)"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 328.45,
    y: 462.65,
    width: 8.95,
    height: 2.91,
    transform: "translate(-75.47 64.8) rotate(-9.99)"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 332.23,
    y: 484.13,
    width: 8.95,
    height: 2.91,
    transform: "translate(-79.14 65.78) rotate(-9.99)"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 335.01,
    y: 505.72,
    width: 8.95,
    height: 2.91,
    transform: "translate(-82.84 66.59) rotate(-9.99)"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 338.87,
    y: 527.74,
    width: 8.95,
    height: 2.91,
    transform: "translate(-86.6 67.59) rotate(-9.99)"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.39,
    y: 1366.78,
    width: 8.95,
    height: 2.91
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.99,
    y: 1333.69,
    width: 8.95,
    height: 2.91
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.99,
    y: 1311.7,
    width: 8.95,
    height: 2.91
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.99,
    y: 1289.41,
    width: 8.95,
    height: 2.91
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.17,
    y: 1267.56,
    width: 8.95,
    height: 2.91
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.39,
    y: 1245.7,
    width: 8.95,
    height: 2.91
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.39,
    y: 1223.88,
    width: 8.95,
    height: 2.91
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.19,
    y: 1201.52,
    width: 8.95,
    height: 2.91
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.01,
    y: 1179.77,
    width: 8.95,
    height: 2.91
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.12,
    y: 1157.68,
    width: 8.95,
    height: 2.91
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.12,
    y: 1135.7,
    width: 8.95,
    height: 2.91
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.66,
    y: 1113.73,
    width: 8.95,
    height: 2.91
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.79,
    y: 1091.75,
    width: 8.95,
    height: 2.91
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.85,
    y: 1069.56,
    width: 8.95,
    height: 2.91
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.9,
    y: 1047.91,
    width: 8.95,
    height: 2.91
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 366.85,
    y: 1025.82,
    width: 8.95,
    height: 2.91
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.17,
    y: 1003.96,
    width: 8.95,
    height: 2.91
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 981.76,
    width: 8.95,
    height: 2.91
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 959.7,
    width: 8.95,
    height: 2.91
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.63,
    y: 937.67,
    width: 8.95,
    height: 2.91
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 915.64,
    width: 8.95,
    height: 2.91
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 893.61,
    width: 8.95,
    height: 2.91
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.01,
    y: 871.77,
    width: 8.95,
    height: 2.91
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 850.05,
    width: 8.95,
    height: 2.91
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 828.33,
    width: 8.95,
    height: 2.91
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.65,
    y: 805.79,
    width: 8.95,
    height: 2.91
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.08,
    y: 784.42,
    width: 8.95,
    height: 2.91
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.01,
    y: 762,
    width: 8.95,
    height: 2.91
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.01,
    y: 739.58,
    width: 8.95,
    height: 2.91
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.34,
    y: 717.72,
    width: 8.95,
    height: 2.91
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 367.01,
    y: 705.72,
    width: 8.95,
    height: 2.91
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(734.16 937.47)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Putz"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: -1.95,
    y: 12
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 1.56,
    y: 12
  }, "aum"))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "886.5 633.56 605.65 656.93 580.15 716.1 608.79 744.7 855.46 744.53 916.1 703.81 886.5 633.56"
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(337.92 1298.13) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.01,
    y: 0
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 27.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.61,
    y: 0
  }, "asse"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(1375.47 859.42) rotate(54.39)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 0,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 9.01,
    y: 0
  }, "er"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 27.6,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 34.61,
    y: 0
  }, "asse"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloor2);
export default __webpack_public_path__ + "static/media/floor2.b36e71ddb77bf84d4c36db59f1e3fa0d.svg";
export { ForwardRef as ReactComponent };